import { render } from "./InvoiceBacklogView.vue?vue&type=template&id=05086067"
import script from "./InvoiceBacklogView.vue?vue&type=script&lang=js"
export * from "./InvoiceBacklogView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__